<template>
  <span :class="bem.b()" v-html="purifiedVal"></span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { createNamespace } from '@ll-plus/utils'
import DOMPurify from 'dompurify'
import { htmlProps } from './html'

// 1.defineOptions
defineOptions({
  name: 'LlHtml',
})
// 定义组件props
const props = defineProps(htmlProps)

const bem = createNamespace('html')

// 自定义配置允许 SVG
const purifyOptions = computed(() => ({
  USE_PROFILES: { html: true, svg: true },
  ADD_TAGS: ['use', 'svg', 'symbol'],
  ADD_ATTR: ['xlink:href', 'viewBox', 'aria-hidden'],
  FORBID_TAGS: ['script', 'iframe', 'object', 'embed'],
  FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover'],
  ...props.options,
}))

// 使用自定义配置过滤 HTML（防止XXS攻击）
const purifiedVal = computed(() => {
  return DOMPurify.sanitize(props.value, purifyOptions.value)
})
</script>
